/* Dr.Primal — the simple sticky kit CTA bar.

   One job: carry a button that scrolls to the kit selector, and stay out of the way
   while the selector is on screen. No prices, no selection, no cart path — the offer
   owns all of that. It smooth-scrolls to the offer's stable `#dp-kit-offer` anchor, and
   reveals once the reader is past the first screen and the offer is nowhere in view. */
(function () {
  'use strict';

  function init() {
    var bar = document.querySelector('[data-dp-kit-cta-bar]');
    if (!bar) return;

    var offer = document.getElementById('dp-kit-offer');
    if (!offer) {
      // Nothing to scroll to — a bar whose one button is dead is worse than no bar.
      bar.hidden = true;
      return;
    }

    /* Two modes. Away from the selector the button scrolls to it; once the selector is on
       screen the button adds the selected kit through the offer's own add path — one
       add-to-cart path on the page, as everywhere else. The mode is read off the bar's
       `data-dp-mode` attribute, set by the scroll rule below, so the click always does
       what the label currently says. */
    var link = bar.querySelector('[data-dp-kit-cta-link]');
    if (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        if (bar.getAttribute('data-dp-mode') === 'add') {
          var add = offer.querySelector('[data-dp-kit-add]');
          if (add) add.click();
        } else {
          offer.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }

    /* The bar's name line mirrors the offer's SELECTED kit, read from the checked
       card's own rendered name - never composed here. The Liquid fallback (the product
       title) stands until the first sync and without JS. */
    var nameNode = bar.querySelector('[data-dp-kit-cta-name]');

    function syncName() {
      if (!nameNode) return;
      var checked = offer.querySelector('[data-dp-kit-radio]:checked');
      var card = checked && checked.closest('[data-dp-kit-card]');
      var label = card && card.querySelector('.dp-kit-card__name');
      if (label) nameNode.textContent = label.textContent.replace(/\s+/g, ' ').trim();
    }

    offer.addEventListener('change', function (event) {
      if (event.target instanceof window.Element && event.target.hasAttribute('data-dp-kit-radio')) {
        syncName();
      }
    });
    syncName();

    function reveal(state) {
      bar.setAttribute('data-dp-revealed', state ? 'true' : 'false');
      if (state) bar.removeAttribute('inert');
      else bar.setAttribute('inert', '');
    }

    var always = bar.getAttribute('data-dp-always') === 'true';

    reveal(always);

    /* Same reveal rule and rationale as the other sticky bars: a scroll+rAF read rather
       than an IntersectionObserver, so a flick or anchor jump past the offer still lands
       the bar in the right state. The bar reveals once past the first screen and then
       stays — it no longer hides when it reaches the offer; instead it flips to add mode
       so its button becomes the add-to-cart control while the kits are in view. */
    var queued = false;

    function update() {
      queued = false;

      var viewport = window.innerHeight || document.documentElement.clientHeight;
      var offerRect = offer.getBoundingClientRect();
      var scrolled = window.pageYOffset || document.documentElement.scrollTop || 0;

      var offerOnScreen = offerRect.bottom > 0 && offerRect.top < viewport;
      // A quarter screen, not a full one (client, 2026-09-18): on the athlete PDP the
      // kits sit near the top, and a full-viewport threshold let the reader scroll two
      // cards deep with no add control in reach.
      var started = scrolled >= viewport * 0.25;

      // Offer already on screen (the athlete PDP's above-the-fold kits): the bar shows
      // from the first frame, in add mode, no scroll needed (client, 2026-09-18). On
      // the landing pages the offer starts far below, so nothing changes there.
      reveal(always || started || offerOnScreen);
      bar.setAttribute('data-dp-mode', offerOnScreen ? 'add' : 'scroll');
    }

    function schedule() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
